module.exports = __webpack_public_path__ + "img/80.7b09ffb7.jpg";